import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationModuleApiSuffixModels, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppState } from '../../../reducers';
import { loggedInUserData } from '../auth.selectors';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent implements OnInit {
  matcher = new passwordErrorStateMatcher();
  resetForm: FormGroup;
  isFormSubmitted = false;
  applicationResponse: IApplicationResponse;
  id: string;
  loggedInUserData: LoggedInUserModel;
  broadcastChannel: BroadcastChannel;
  labelStyle = { 'color': '#8A8A8A'};
  passwordEyeStyle = { 'position': 'absolute', 'top': '45px', 'right': '14px' };

  constructor(private formBuilder: FormBuilder, private router: Router,
    private activatedRoute: ActivatedRoute,
    private crudService: CrudService, private rxjsService: RxjsService, private store: Store<AppState>) {
    this.rxjsService.setDialogOpenProperty(true);
  }

  ngOnInit() {
    this.combineLatestNgrxStoreData();
    this.createResetPasswordFormGroup();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.activatedRoute.params,
      this.store.select(loggedInUserData)
    ]).pipe(take(1)).subscribe((response) => {
      this.id = response[0]?.id;
      this.loggedInUserData = response[1];
    });
  }

  createResetPasswordFormGroup(): void {
    this.resetForm = this.formBuilder.group({
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
      verificationCode: ['', [Validators.required]]
    }, {
      validator: this.checkPasswords
    });
  }

  checkPasswords(group: FormGroup) {
    let pass = group.controls.password.value;
    let confirmPass = group.controls.confirmPassword.value;
    return (confirmPass == "") || pass === confirmPass ? null : { notSame: true }
  }

  onSubmit() {
    this.isFormSubmitted = true;
    if (this.resetForm.invalid) {
      return;
    }
    this.resetForm.value.id = this.id;
    this.crudService.create(ModulesBasedApiSuffix.AUTHENTICATION, AuthenticationModuleApiSuffixModels.GENERATE_PASSWORD,
      this.resetForm.value).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          if (this.loggedInUserData?.userId) {
            // Helps to share the encoded token after refresh token across the angular opened tabs
            this.broadcastChannel = new BroadcastChannel("Refresh Token Sharing Between Tabs");
            this.broadcastChannel.postMessage({
              userId: this.loggedInUserData.userId
            });
          }
          this.router.navigateByUrl('login');
          localStorage.clear();
        }
      });
  }

  ngOnDestroy() {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
export class passwordErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);
    return (invalidCtrl || invalidParent);
  }
}
